import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef, ViewEncapsulation, ViewChild } from '@angular/core';
import {DemoService} from '../../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../../services/mysql.service';

import { Job } from '../../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject} from 'rxjs';
import { Subscription } from 'rxjs';



@Component({
  selector: 'app-subject-cost-tab',
  templateUrl: './subject-cost-tab.component.html',
  styleUrls: ['./subject-cost-tab.component.css']
})
export class SubjectCostTabComponent implements OnInit {


  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  sessionUserLevel: any;
  brand_id: any;
  subject_id: number;
  subjects: Object;
  job_id: any;
  file_number: any;

  constructor(private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService, ) {

    // login vars
this.currentUserVAR = JSON.parse(sessionStorage.getItem('currentUser'));
console.log('sessionUserId: ', this.currentUserVAR.user_id );
console.log('sessionUsername: ', this.currentUserVAR.username );
// Set loggind in User Value (USER ID)
this.sessionUserId = this.currentUserVAR.user_id;
this.sessionUsername = this.currentUserVAR.username;
this.sessionBrandId = this.currentUserVAR.brand_id;
this.sessionUserLevel = this.currentUserVAR.access_level;
this.brand_id = this.sessionBrandId;
// this.toastr.setRootViewContainerRef(vcr);
   }

  ngOnInit() {

    this.subject_id = +this.route.snapshot.paramMap.get('subject_id');
    this.getJobSubject(this.subject_id);
  }




  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
       data => { this.subjects = data;
        const res = data[0];
      //  this.getSubjectNotes(res.subject_id);
        // load subject history

        this.job_id = res.job_id; // set for include component on template
        this.file_number = res.file_number; // included component on template
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


}

